// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2OKEc","Label":"BuildControl_Label__9ySyP","Less":"BuildControl_Less__1lq3V","More":"BuildControl_More__2DUCP"};